export const environment = {
  production: true,

  /* -------------------- TOKENS -------------------- */
  xToken: "xtoken",
  xrefreshToken: "xrefreshToken",

  /* -------------------- API CONFIG -------------------- */
  baseUrl: "https://api-dev.jhacasso.com/api/",

  defaultApiVersion: "v1",

  authKey: "trwmjhwiodljerok9OqeO7huL",
  appKey: "a1b2c33d4e5f6g7h8i9jakblc",

  /* -------------------- APP INFO -------------------- */
  appVersion: '1.0.38',

  /* -------------------- GOOGLE -------------------- */
  googleMapsApiKey: ""
};
export const countryCode = [{ name: "India", dial_code: "+91", code: "IN" }];